import { POST_ADM } from '../../../../services/api'
import { ConciergeMode } from '../types/communication.types'

/**
 * Interface para o request de atualização do modo de operação
 */
export interface UpdateConciergeModeRequest {
  sessionKey: string
  hotelId: number
  room: string
  reservationId: string
  conciergeMode: ConciergeMode
}

/**
 * Interface para o response da atualização
 */
export interface UpdateConciergeModeResponse {
  success: boolean
  typemsg: 'info' | 'error' | 'success' | 'warning'
  message: string
}

/**
 * Serviço para gerenciar o modo de operação do concierge
 */
export class ConciergeModeService {
  /**
   * Atualiza o modo de operação de uma sessão
   */
  static async updateConciergeMode(
    data: UpdateConciergeModeRequest
  ): Promise<UpdateConciergeModeResponse> {
    try {
      const response = await POST_ADM('/communication-center/conciergeModeInfo', data)
      return response as UpdateConciergeModeResponse
    } catch (error) {
      console.error('Erro ao atualizar concierge mode:', error)
      throw error
    }
  }
}

/**
 * Labels para os modos de operação
 */
export const CONCIERGE_MODE_LABELS: Record<ConciergeMode, string> = {
  manual: 'Manual',
  assisted: 'Assistido',
  autopilot: 'Piloto Automático'
}

/**
 * Descrições detalhadas dos modos de operação
 */
export const CONCIERGE_MODE_DESCRIPTIONS: Record<ConciergeMode, string> = {
  manual: 'Funcionário responde tudo manualmente',
  assisted: 'IA sugere respostas para aprovação',
  autopilot: 'IA responde automaticamente'
}

/**
 * Ícones para os modos de operação
 */
export const CONCIERGE_MODE_ICONS: Record<ConciergeMode, string> = {
  manual: 'fa-user',
  assisted: 'fa-user-cog',
  autopilot: 'fa-robot'
}

/**
 * Cores para os modos de operação
 */
export const CONCIERGE_MODE_COLORS: Record<ConciergeMode, string> = {
  manual: '#3699FF', // Azul
  assisted: '#FFA800', // Laranja
  autopilot: '#50CD89' // Verde
}
